<template>
  <div class="c-card-body">
    <v-form
      v-if="canAccessForm"
      ref="form"
      v-model="valid"
      :readonly="readOnly"
    >
      <v-container>
        <v-col cols="12" md="6">
          <v-radio-group
            v-model="data.sales_by_role"
            row
            label="Pilih Role Sales"
            class="mt-1"
          >
            <v-radio label="FC" value="fitness-consultant" />
            <v-radio label="PT" value="personal-trainer" />
          </v-radio-group>
        </v-col>
        <v-row no-gutters>
          <v-col style="text-align: right">
            <v-row class="mt-1 justify-end mr-10">
               <v-chip
               v-if="data.creator_name"
              class="mr-3"
              small
              outlined
              color="primary"
              label
            >
              <v-icon left small>mdi-account</v-icon>
              Dibuat oleh {{ data.creator_name }} 
            </v-chip>
              <div class="text-center">
                <v-btn
                  width="30px"
                  v-if="showEditButton"
                  style="margin-left: 7px; margin-right: 7px"
                  rounded
                  depressed
                  color="#FEC400"
                  dark
                  @click="goToEditPage()"
                >
                  Edit
                </v-btn>
                <v-btn
                  width="30px"
                  v-if="showDeleteButton"
                  rounded
                  depressed
                  essed
                  color="#F12B2C"
                  dark
                  @click="onClickDelete()"
                >
                  Delete
                </v-btn>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <v-col cols="12" md="12">
        <v-card outlined>
          <v-container>
            <v-card-title>
              <strong>Item Paket</strong>
              <v-spacer></v-spacer>
              <v-btn icon small @click="addItem">
                <v-icon color="blue">mdi-plus</v-icon>
              </v-btn>
            </v-card-title>

            <!-- eslint-disable prettier/prettier -->
            <div v-for="(item, index) in data.items" :key="index" class="mb-4">
              <v-card outlined>
                <v-card-title>
                  <span>
                    Paket {{ index + 1 }} -
                    {{ getPackageName(item.package_id) || "Belum dipilih" }}  
                  </span>
                  <span v-if="item.from_member_id != null">
                     (Paket ini telah ditransfer ke member lain)
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn v-if="item.from_member_id == null" icon @click.stop="removeItem(index)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        dense
                        outlined
                        label="Pilih Paket"
                        v-model="item.package_id"
                        :items="listPackages"
                        item-text="name"
                        item-value="id"
                        clearable
                        @change="updatePackageSettings(index)"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete
                        label="Promo"
                        dense
                        outlined
                        v-model="item.promo_id"
                        :items="item.promos"
                        item-text="name"
                        item-value="id"
                        clearable
                        @change="updateItemPrice(index)"
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Free Membership (bulan)"
                        dense
                        outlined
                        type="number"
                        v-model="item.free_month"
                        min="1"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        label="Free Sesi"
                        dense
                        outlined
                        type="number"
                        v-model="item.free_session"
                        min="1"
                        :disabled="!item.is_session"
                        :readonly="!item.is_session"
                        :rules="getFreeSessionRules(item)"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-center">
                      <v-checkbox
                        label="Sesi Trial"
                        v-model="item.trial_session"
                        :disabled="!item.is_session"
                        :readonly="!item.is_session"
                        class="mt-0"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="
                        item.is_session ||
                        data.sales_by_role === 'personal-trainer'
                      "
                    >
                      <v-autocomplete
                        label="Personal Trainer"
                        dense
                        outlined
                        v-model="item.personal_trainer_id"
                        :items="listPersonalTrainers"
                        item-text="name"
                        item-value="id"
                        clearable
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="
                        item.is_session ||
                        data.sales_by_role === 'fitness-consultant'
                      "
                    >
                      <v-autocomplete
                        label="Fitness Consultant"
                        dense
                        outlined
                        v-model="item.fitness_consultant_id"
                        :items="listFitnessConsultants"
                        item-text="name"
                        item-value="id"
                        clearable
                        :rules="getFitnessConsultantRules(item)"
                      />
                    </v-col>
                    <v-row>
                      <v-col cols="12" md="4">
                        <label>Harga Dasar</label>
                        <CurrencyInput
                          v-model="item.price_bottom"
                          :rules="rules.price"
                          placeholder="Masukkan harga paket"
                          class="readonly"
                          readonly
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <label>Harga Sales</label>
                        <CurrencyInput
                          v-model="item.price_sales"
                          placeholder="Masukkan harga sales"
                          :rules="[(v) => !!v || 'Harga Sales harus diisi']"
                          class="readonly"
                          readonly
                        />
                      </v-col>

                      <v-col cols="12" md="4">
                        <label>Tanggal Mulai Paket</label>
                        <small v-if="item.is_tentative" class="text--secondary">
                          Paket bersifat tentative, tanggal tidak diperlukan.
                        </small>
                        <date-picker
                          class="mb-6"
                          placeholder="Tanggal Mulai Paket"
                          valueType="format"
                          :format="'YYYY-MM-DD'"
                          v-model="item.start_date"
                          @change="updateExpiredDate(index)"
                          :rules="[(v) => !!v || 'Tanggal Mulai Paket harus diisi']"
                          :disabled="item.is_tentative"            
                          :readonly="item.is_tentative"
                        ></date-picker>
                      </v-col>

                      <v-col cols="12" md="4">
                        <label>Tanggal Expired Paket</label>
                        <small v-if="item.is_tentative" class="text--secondary">
                        Paket bersifat tentative, tanggal tidak diperlukan.
                      </small>
                        <date-picker
                          class="mb-6"
                          placeholder="Tanggal Kadaluarsa"
                          valueType="format"
                          :format="'YYYY-MM-DD'"
                          v-model="item.expired_date"
                          :rules="[(v) => !!v || 'Tanggal Kadaluarsa harus diisi']"
                          :disabled="item.is_tentative"            
                          :readonly="item.is_tentative"
                        ></date-picker>
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex align-center">
                        <v-checkbox
                          label="Progress Book"
                          v-model="item.progress_book"
                          :disabled="!item.is_session"
                          :readonly="!item.is_session"
                          class="mt-0"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="d-flex align-center" v-if="canVerification">
                        <v-checkbox
                          label="Apakah Tentative?"
                          v-model="item.is_tentative"
                          class="mt-0"
                          @change="onToggleTentative(index)"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <!-- eslint-enable prettier/prettier -->
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="12">
        <v-card outlined style="padding-bottom: 0">
          <v-container>
            <v-row dense>
              <v-col cols="12" md="12">
                <v-autocomplete
                  label="Member"
                  dense
                  outlined
                  v-model="data.member_id"
                  :items="listMembers"
                  item-text="name"
                  item-value="id"
                  :rules="rules.member_id"
                  class="mb-4"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label style="font-size: 16px; font-weight: bold">
                  Total Harga Paket:<br />
                  Rp
                  {{ new Intl.NumberFormat("id-ID").format(totalHarga) }}
                </label>
              </v-col>

              <label style="font-size: 16px; font-weight: bold">
                Total Harga Sales:<br />
                Rp
                {{ new Intl.NumberFormat("id-ID").format(totalHargaSales) }}
              </label>

              <v-col cols="12" md="12">
                <v-textarea
                  label="Deskripsi"
                  dense
                  outlined
                  rows="3"
                  v-model="data.description"
                  class="mb-4"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  label="Merchandise"
                  dense
                  outlined
                  v-model="data.merchandise_id"
                  :items="listMerchandise"
                  item-text="name"
                  item-value="id"
                  :rules="merchandiseIdRules"
                  class="mb-4"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Jumlah Merchandise"
                  dense
                  outlined
                  v-model="data.merchandise_amount"
                  class="mb-4"
                  :rules="merchandiseAmountRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-if="canVerification"
                  label="Status"
                  dense
                  outlined
                  v-model="data.status"
                  :items="listStatuses"
                  item-text="name"
                  item-value="id"
                  clearable
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="12">
        <v-card outlined>
          <v-container>
            <v-card-title>
              <strong>Rincian Pembayaran</strong>
              <v-spacer></v-spacer>
              <v-btn icon small @click="addPayment">
                <v-icon color="blue">mdi-plus</v-icon>
              </v-btn>
            </v-card-title>

            <!-- eslint-disable prettier/prettier -->
            <div
              v-for="(item, index) in data.payments"
              :key="index"
              class="mb-4"
            >
              <v-card outlined>
                <v-card-title>
                  <span> Pembayaran - {{ index + 1 }} </span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.stop="removePayment(index)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        label="Metode Pembayaran"
                        dense
                        outlined
                        v-model="item.payment_method_id"
                        :items="listPaymentMethods"
                        item-text="name"
                        item-value="id"
                        clearable
                        :rules="rules.payment_method_id"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete
                        label="Bank Tujuan"
                        dense
                        outlined
                        v-model="item.destination_bank_id"
                        :items="listBanks"
                        item-text="name"
                        item-value="id"
                        clearable
                        :rules="rules.destination_bank_id"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="No. Rekening"
                        dense
                        outlined
                        v-model="item.account_number"
                        :rules="rules.account_number"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Nama Rekening"
                        dense
                        outlined
                        v-model="item.account_name"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <CurrencyInput
                        v-model="item.amount"
                        placeholder="Masukkan jumlah pembayaran"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <date-picker
                        class="mb-6"
                        placeholder="Tanggal Pembayaran"
                        valueType="format"
                        :format="'YYYY-MM-DD'"
                        v-model="item.payment_date"
                        :rules="rules.payment_date"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="ml-3">Bukti Transfer</div>
                      <FileUpload
                        v-model="item.transfer_evidence_id"
                        :labelIdle="'Unggah Bukti Transfer'"
                        category="file"
                        class="mb-6"
                      ></FileUpload>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
            <!-- eslint-enable prettier/prettier -->
          </v-container>
        </v-card>
      </v-col>

      <v-container>
        <v-row no-gutters class="mr-10">
          <v-col cols="6" style="margin-top: -15px">
            <p v-if="this.id !== null">
              <label></label>
              {{ data.id ? getDate(data.updated_at) : "" }}
            </p>
          </v-col>
          <v-col v-if="activity !== 'lihat'" cols="6" style="margin: 10px 0">
            <v-row style="display: flex; justify-content: flex-end">
              <!-- back button danger -->
              <v-btn
                rounded
                color="#F12B2C"
                dark
                depressed
                class="ma-1"
                @click.prevent="back()"
                ><v-icon small left>mdi-arrow-left</v-icon>
                Kembali
              </v-btn>
              <v-btn
                v-if="canCreate"
                type="submit"
                rounded
                color="#0B173B"
                dark
                depressed
                class="ma-1"
                :loading="loading"
                @click.prevent="save()"
                ><v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <delete-dialog
      ref="delete"
      url="sales"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { asset } from "@/core/utils";
import ApiService from "@/core/services/api.service";

import router from "@/router";

import DeleteDialog from "@/view/component/DeleteDialog";

import FileUpload from "@/view/component/FileUpload.vue";

import moment from "moment";

export default {
  mounted() {
    const pathArray = window.location.pathname.split("/");
    const id = pathArray[4];
    this.activity = pathArray[3];
    this.getBreadcrumbs();

    // Lanjutkan semua fetch dulu
    this.fetchInitialData(id);
  },
  props: {
    success: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      module: "sales",
      editorOption: {},
      activeTab: 0,
      action: "post",
      id: null,
      listUser: [],
      opened: false,
      loading: false,
      loadingData: false,
      isLoadingZone: false,
      isLoadingRegion: false,
      searchRegion: "",
      regionName: "",
      valid: true,
      dataFile: null,
      activity: "",
      scheduled: false,
      enableListUser: false,
      form: {
        content: null,
      },
      search: null,
      listStatuses: ["unverified", "verified"],
      listMembers: [],
      listMerchandise: [],
      listPackages: [],
      listPersonalTrainers: [],
      listFitnessConsultants: [],
      listPaymentMethods: [],
      listBanks: [],
      listPromos: [],
      data: {
        sales_by_role: "fitness-consultant",
        member_id: null,
        merchandise_id: null,
        merchandise_amount: null,
        status_payment: "unpaid",
        status: "unverified",
        price: 0,
        price_sales: 0,
        items: [],
        payments: [],
      },
      paymentStatuses: ["paid", "unpaid", "dp"],
      statuses: ["unverified", "verified"],
      rules: {
        member_id: [(v) => !!v || "Member harus dipilih"],
        payment_status: [(v) => !!v || "Status Pembayaran harus dipilih"],
        status: [(v) => !!v || "Status harus dipilih"],
        fitness_consultant_id: [
          (v) => !!v || "Fitness Consultant harus dipilih",
        ],
        personal_trainer_id: [(v) => !!v || "Personal Trainer harus dipilih"],
        price: [(v) => !!v || "Harga harus diisi"],
        start_date: [(v) => !!v || "Tanggal Mulai harus diisi"],
        expired_date: [(v) => !!v || "Tanggal Kadaluarsa harus diisi"],
        price_sales: [
          (v) => !!v || "Price Sales harus diisi",
          (v) => Number(v) > 0 || "Price Sales tidak boleh kurang dari 0",
          (v) =>
            Number(v) > this.totalHarga ||
            "Price Sales tidak boleh kurang dari Harga Paket",
        ],
        account_number: [(v) => !!v || "No Rekening harus diisi"],
        account_name: [(v) => !!v || "Nama Rekening harus diisi"],
        payment_method_id: [(v) => !!v || "Metode Pembayaran harus dipilih"],
        destination_bank_id: [(v) => !!v || "Bank Tujuan harus dipilih"],
        payment_date: [(v) => !!v || "Tanggal Pembayaran harus diisi"],
      },
    };
  },
  methods: {
    onToggleTentative(index) {
      const item = this.data.items[index];
      if (item.is_tentative) {
        // Kalau jadi tentative -> kosongkan tanggal
        item.start_date = null;
        item.expired_date = null;
      } else {
        // Kalau tidak tentative lagi, biarkan user isi kembali (tidak perlu set apa-apa)
      }
    },
    getFitnessConsultantRules(item) {
      if (!item.is_monthly && !item.is_class) {
        return []; // artinya ini sesi, gak butuh FC
      }

      return this.rules.fitness_consultant_id;
    },
    async fetchInitialData(id) {
      this.loadingData = true;
      try {
        this.listMembers = (
          await ApiService.get("user/list?role_slug=member")
        ).data;
        this.listMerchandise = (await ApiService.get("merchandise/list")).data;
        this.listPersonalTrainers = (
          await ApiService.get("user/list?role_slug=personal-trainer")
        ).data;
        this.listFitnessConsultants = (
          await ApiService.get("user/list?role_slug=fitness-consultant")
        ).data;
        const packages = (await ApiService.get("package/list")).data;
        this.listPackages = packages.map((pkg) => this.mapPackage(pkg));
        this.listBanks = (await ApiService.get("bank/list")).data;
        this.listPaymentMethods = (
          await ApiService.get("payment-method/list")
        ).data;
        this.listPromos = (await ApiService.get("promo/list")).data;

        if (id) {
          this.open(id); // ✅ sekarang sudah aman dipanggil
        }
      } finally {
        this.loadingData = false;
      }
    },
    asset,
    mapPackage(pkg) {
      return {
        id: pkg.id,
        name: pkg.name,
        price_sales: parseFloat(pkg.price_sales),
        price_bottom: parseFloat(pkg.price_bottom),
        is_monthly: pkg.is_monthly || false,
        is_session: pkg.is_session || false,
        is_class: pkg.is_class || false,
        duration_month: pkg.duration_month || 0,
        session_count: pkg.session_count || 0,
      };
    },
    getPackageName(id) {
      const pkg = this.listPackages.find((p) => p.id === id);
      return pkg ? pkg.name : null;
    },
    getBreadcrumbs() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Sales", route: "" },
        { title: "Sales", route: "" },
        {
          title:
            this.activity === "tambah"
              ? "Tambah Sales"
              : this.activity === "edit"
              ? "Edit Sales"
              : this.activity === "lihat"
              ? "Lihat Sales"
              : "",
        },
      ]);
    },
    getFreeSessionRules(item) {
      if (!item.is_session) return [];

      return [
        // (v) => !!v || "Free Session harus diisi",
        (v) => {
          const val = parseInt(v);
          return val <= 4 || "Free Session tidak boleh lebih dari 4";
        },
      ];
    },
    async updatePackageSettings(index) {
      const item = this.data.items[index];
      const selectedPackage = this.getPackageDetails(item.package_id);
      item.is_monthly = selectedPackage?.is_monthly || false;
      item.is_session = selectedPackage?.is_session || false;
      item.is_class = selectedPackage?.is_class || false;
      item.price = parseFloat(selectedPackage?.price_sales) || 0;
      item.trial_session = false;
      item.start_date = null;
      item.expired_date = null;
      item.free_month = null;
      item.free_session = null;
      item.progress_book = false;
      item.personal_trainer_id = null;
      item.fitness_consultant_id = null;
      item.start_date = null;
      item.expired_date = null;
      item.is_tentative = false;

      // Reset nilai jika paket tidak mendukung fitur
      if (!item.is_monthly && !item.is_class) {
        item.free_month = null;
        // item.fitness_consultant_id = null;
      }
      if (!item.is_session) {
        item.free_session = null;
        // item.personal_trainer_id = null;
      }

      // Filter promos based on package type
      item.promo_id = null; // Reset promo
      item.promos = this.listPromos.filter((promo) => {
        if (item.is_monthly) return promo.is_monthly;
        if (item.is_session) return promo.is_session;
        if (item.is_class) return promo.is_class;
        return false;
      });
      // Set initial price
      item.price = this.calculatePackagePrice(
        parseFloat(selectedPackage?.price_sales),
        item.promo_id
      );
      item.price_bottom = parseFloat(selectedPackage?.price_bottom) || 0;
      item.price_sales = this.calculatePackagePrice(
        parseFloat(selectedPackage?.price_sales),
        item.promo_id
      );
    },
    calculatePackagePrice(priceSales, promoId) {
      if (!priceSales) return 0;

      // Jika promo belum dipilih, gunakan harga penjualan penuh
      if (!promoId) return priceSales;

      // Cari promo berdasarkan ID
      const promo = this.listPromos.find((promo) => promo.id === promoId);
      if (!promo) return priceSales;

      // Hitung harga setelah diskon, dibulatkan ke rupiah agar konsisten
      // dengan nilai yang ditampilkan dan dikirim ke API (hindari sisa
      // pecahan floating-point seperti 1649999.9999999409)
      const discount = parseFloat(promo.percentage) || 0;
      const finalPrice = Math.round(priceSales - (priceSales * discount) / 100);
      const selectedPackage = this.getPackageDetails(
        this.data.items.find((item) => item.promo_id === promoId)?.package_id
      );

      if (finalPrice <= selectedPackage?.price_bottom) {
        return selectedPackage?.price_bottom;
      }
      return Math.max(0, finalPrice);
    },

    // Update harga ketika promo dipilih
    updateItemPrice(index) {
      const item = this.data.items[index];
      const selectedPackage = this.getPackageDetails(item.package_id);
      item.price = this.calculatePackagePrice(
        selectedPackage?.price_sales,
        item.promo_id
      );
      item.price_sales = this.calculatePackagePrice(
        selectedPackage?.price_sales,
        item.promo_id
      );
    },
    updateExpiredDate(index) {
      const item = this.data.items[index];
      if (!item.start_date) return;

      const selectedPackage = this.getPackageDetails(item.package_id);
      const duration = Number(selectedPackage?.duration_month || 0);
      const free = Number(item.free_month || 0);
      const totalMonth = duration + free;

      if ((item.is_monthly || item.is_class) && totalMonth > 0) {
        item.expired_date = moment(item.start_date)
          .add(totalMonth, "months")
          .format("YYYY-MM-DD");
      }
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get(`sales?id=${id}`)
        .then(async ({ data }) => {
          // Paket yang sudah di-nonaktifkan tidak lagi dikembalikan oleh
          // package/list, tapi transaksi lama tetap perlu menampilkan
          // nama & detail paketnya. Ambil satu-satu by id agar tetap muncul.
          const missingPackageIds = [
            ...new Set(
              data.items
                .map((item) => item.package_id)
                .filter(
                  (pkgId) =>
                    pkgId && !this.listPackages.some((p) => p.id === pkgId)
                )
            ),
          ];

          await Promise.all(
            missingPackageIds.map(async (pkgId) => {
              const inactivePackages = (
                await ApiService.get(`package/list?id=${pkgId}`)
              ).data;
              this.listPackages.push(
                ...inactivePackages.map((pkg) => this.mapPackage(pkg))
              );
            })
          );

          this.data = {
            creator_name: data.creator.name || null,
            code: data.code,
            member_id: data.member_id,
            status: data.status,
            sales_by_role: data.sales_by_role || "fitness-consultant",
            status_payment: data.status_payment,
            price: Math.round(Number(data.price) || 0),
            price_sales: Math.round(Number(data.price_sales) || 0),
            description: data.description,
            merchandise_id: data.merchandise_id || null,
            merchandise_amount: data.merchandise_amount || 0,
            items: data.items.map((item) => {
              const pkg = this.getPackageDetails(item.package_id);

              return {
                ...item,
                is_monthly: pkg?.is_monthly || false,
                is_session: pkg?.is_session || false,
                is_class: pkg?.is_class || false,
                trial_session:
                  item.trial_session != null &&
                  item.trial_session > 0 &&
                  pkg?.is_session
                    ? true
                    : false,
                fitness_consultant_id: item.fitness_consultant_id || null,
                personal_trainer_id: item.personal_trainer_id || null,
                promo_id: item.promo_id || null,
                promos: this.listPromos.filter((promo) => {
                  if (pkg?.is_monthly) return promo.is_monthly;
                  if (pkg?.is_session) return promo.is_session;
                  if (pkg?.is_class) return promo.is_class;
                  return false;
                }),
                price: Math.round(Number(item.price) || 0),
                price_sales: Math.round(Number(item.price_sales) || 0),
                price_bottom: parseFloat(pkg?.price_bottom) || 0,
              };
            }),
            payments: data.payments.map((payment) => ({
              ...payment,
            })),
          };
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
        });
    },

    open(id) {
      if (id) {
        this.action = "update";
      } else {
        this.action = "post";
      }

      this.opened = true;

      if (id) {
        this.getData(id);
      } else {
        this.data.image_id = null;
      }
    },
    async back() {
      router.push({ name: "sales" });
    },
    getPackageDetails(packageId) {
      return this.listPackages.find((pkg) => pkg.id === packageId) || {};
    },
    async addItem() {
      this.data.items.push({
        package_id: null,
        free_month: null,
        free_session: null,
        is_monthly: false,
        is_session: false,
        is_class: false,
        price: 0,
        price_sales: 0,
        trial_session: false,
        start_date: null,
        expired_date: null,
        progress_book: false,
        is_tentative: false,
        promos: [], // Tambahkan ini untuk menyimpan promo per paket
        promo_id: null, // Untuk menyimpan promo yang dipilih
        personal_trainer_id:
          this.data.sales_by_role === "personal-trainer" ? null : null,
        fitness_consultant_id:
          this.data.sales_by_role === "fitness-consultant" ? null : null,
      });
    },

    async removeItem(index) {
      this.data.items.splice(index, 1);
    },
    addPayment() {
      this.data.payments.push({
        payment_method_id: null,
        destination_bank_id: null,
        account_number: "",
        account_name: "",
        amount: 0,
        payment_date: null,
        transfer_evidence_id: null,
      });
    },
    removePayment(index) {
      this.data.payments.splice(index, 1);
    },
    async save() {
      this.$refs.form.validate();

      for (const item of this.data.items) {
        if (Number(item.price_sales) < Number(item.price)) {
          this.$swal.fire({
            icon: "warning",
            title: "Harga Sales Kurang",
            text: "Harga sales tidak boleh lebih kecil dari harga paket.",
          });
          return;
        }
      }

      // Guard tanggal
      for (const [i, item] of this.data.items.entries()) {
        const required = (item.is_monthly || item.is_class || item.is_session) && !item.is_tentative;;
        if (required && (!item.start_date || !item.expired_date)) {
          this.$swal.fire({
            icon: "warning",
            title: `Paket ${i + 1}: Tanggal wajib diisi`,
            text: "Tanggal Mulai dan Kadaluarsa wajib diisi untuk paket ini.",
          });
          return;
        }
        if (item.start_date && item.expired_date) {
          if (new Date(item.expired_date) < new Date(item.start_date)) {
            this.$swal.fire({
              icon: "warning",
              title: `Paket ${i + 1}: Tanggal tidak valid`,
              text: "Tanggal Kadaluarsa tidak boleh sebelum Tanggal Mulai.",
            });
            return;
          }
        }
      }

      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "sales";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        let _data = {
          ...this.data,
          price_sales: this.totalHargaSales, // pakai total dari item
        };
        ApiService[action](url, _data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              router.push({ name: "sales" });
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },

    goToEditPage() {
      this.activity = "edit";
      this.getBreadcrumbs();
      router.push({ name: "edit", params: { id: this.id } });
      this.getData(this.id);
    },

    onClickDelete() {
      this.$refs.delete.open(this.id);
    },
    onClickVerification() {
      this.$refs.delete.open(this.id);
    },
    deleteSuccess() {
      router.push({ name: "sales" });
    },
    syncFitnessConsultant(index) {
      const currentFc = this.data.items[index].fitness_consultant_id;

      this.data.items.forEach((item, i) => {
        if (i !== index && (item.is_monthly || item.is_class)) {
          item.fitness_consultant_id = currentFc;
        }
      });
    },
    getDate(date) {
      date = new Date(date);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dt = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      return dt + "." + month + "." + year + " - " + hour + ":" + minute;
    },
  },
  watch: {
    "data.sales_by_role"(newVal) {
      this.data.items = this.data.items.map((item) => {
        // hanya reset FC jika paketnya monthly atau class
        if (item.is_monthly || item.is_class) {
          return {
            ...item,
            fitness_consultant_id:
              newVal !== "fitness-consultant"
                ? null
                : item.fitness_consultant_id,
            personal_trainer_id:
              newVal !== "personal-trainer" ? null : item.personal_trainer_id,
          };
        }
        return item;
      });
    },
  },
  components: {
    DeleteDialog,
    FileUpload,
  },
  computed: {
    merchandiseIdRules() {
    return [
      (v) => {
        // jika jumlah > 0 → merchandise wajib dipilih
        return Number(this.data.merchandise_amount) > 0
          ? !!v || "Merchandise harus dipilih"
          : true;
      },
    ];
  },
  merchandiseAmountRules() {
    return [
      (v) => {
        // jika merchandise dipilih → minimal 1
        if (this.data.merchandise_id) {
          return Number(v) >= 1 || "Jumlah Merchandise harus lebih dari 0";
        }
        // kalau merchandise kosong → bebas (0 juga boleh)
        return true;
      },
    ];
  },
    canCreate() {
      return this.$store.getters.hasPermission(this.module, "create");
    },

    canEdit() {
      return (
        this.id && this.$store.getters.hasPermission(this.module, "update")
      );
    },

    canDelete() {
      return (
        this.id && this.$store.getters.hasPermission(this.module, "delete")
      );
    },
    canVerification() {
      return (
        this.id &&
        this.$store.getters.hasPermission(this.module, "verification")
      );
    },

    canView() {
      return this.$store.getters.hasPermission(this.module, "view");
    },

    readOnly() {
      return this.canView && this.activity === "lihat";
    },

    allowRemoveImage() {
      if (this.activity === "tambah" && this.canCreate) {
        return true;
      } else if (this.activity === "edit" && this.canEdit) {
        return true;
      }
      return false;
    },

    clearable() {
      return (this.canCreate || this.canEdit) && this.activity !== "lihat";
    },
    canAccessForm() {
      if (this.activity === "tambah") {
        if (this.canView && this.canCreate) {
          return true;
        }
      } else if (this.activity === "edit") {
        if (this.canView && this.canEdit) {
          return true;
        }
      } else if (this.activity === "lihat") {
        if (this.canView) {
          return true;
        }
      }
      return false;
    },

    totalHarga() {
      return this.data.items.reduce((sum, item) => {
        return sum + (Number(item.price) || 0);
      }, 0);
    },
    totalHargaSales() {
      return this.data.items.reduce((sum, item) => {
        return sum + (Number(item.price_sales) || 0);
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.readonly {
  color: #888888 !important; /* warna abu-abu */
  background-color: #f9f9f9 !important; /* opsional: abu terang */
  cursor: not-allowed;
}
</style>
